'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BulletListContent = renderWithRef('BulletListContent', null, (o, r)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        classNames: [
            'swan-bullet-list-contents'
        ],
        props: o,
        children: o.children
    }));

export { BulletListContent };
